import { gql } from '@apollo/client';

export const DELETE_DOCUMENT_CLAUSE = gql`
  mutation deleteDocumentClause($input: DeleteDocumentClauseInput) {
    deleteDocumentClause(input: $input) {
      commandId
    }
  }
`;

export const EXPORT_DOCUMENT_CLAUSE_LIST = gql`
  mutation exportDocumentClauseList($filters: ExportDocumentClauseListInput) {
    exportDocumentClauseList(filters: $filters) {
      fileId
      fileName
      filePath
    }
  }
`;
